import lang from 'dojo/_base/lang';
import { compose, mdsWidget } from 'dojo/_base/declare';
import template from './DynamicSidebar.html?raw';
import topic from 'dojo/topic';
import on from 'dojo/on';
import "./SidebarTypes";
import domConstruct from 'dojo/dom-construct';
import domClass from 'dojo/dom-class';
import _WidgetBaseSP from 'more/_WidgetBaseSP';
import SessionInfo from '../Session/SessionInfo';
import FloatingMenu from '../../UI/Floating/Menu';
import GenericDialog from '../../UI/GenericDialog/GenericDialog';
import UserSubstitutionForm from '../Session/UserSubstitution';
import { FeatureHelpers, StringHelpers, ToasterHelpers } from "../../../more/Helpers";
import ExpandableSection from '../../UI/Container/ExpandableSection';
import PageStack from '../../UI/Tabbing/PageStack';
import { ExpandableSectionMarkings } from "../../UI/Container/ExpandableSectionTypes";


interface SidebarLinkCache {
    sessionId: string,
    sidebarLinks: Array<Sidebar.Link>,
    rolesHash: string,
    language: string
}

class DynamicSidebar extends compose(_WidgetBaseSP) {
    templateString: any = template;

    private cornerLinkHome: HTMLLinkElement;

    private verticalContainer: HTMLElement;
    private scrollingContainer: HTMLElement;
    private userInfoContainer: HTMLElement;
    private avatarPlaceholderIcon: HTMLElement;
    private menuContainer: HTMLElement;
    private sidebarOverlay: HTMLElement;
    private logoutContainer: HTMLElement;
    private logoContainerSmall: HTMLElement;
    private topContainer: HTMLElement;
    private iconPin: HTMLElement;
    private sidebarPinButton: HTMLElement;
    private userPic: HTMLElement;
    private username: HTMLElement;
    private substUsername: HTMLElement;
    private substituteDisplayname: HTMLElement;
    private substituteUsernameContainer: HTMLElement;
    private userDisplayname: HTMLElement;
    private langSelect: any; // TODO

    private isOpened: boolean = false;
    private langSelectVisible: boolean = false;
    private _isPinningChange: boolean = false;
    private _isSidebarPinned: boolean = false;
    isPinned: boolean = false;
    private sidebarLinkRegistry: Array<Sidebar.LinkEntry> = [];

    private currentExtraPadding: string = "";
    private currentMainContentPadding: string = "";
    private mainContentNode: HTMLElement;
    private _initialMainContentPadding: string = "";
    private sidebarWidth: string = "200px";
    private collapsedWidth: string = "20px";

    private responsiveThresholdPX: number = 1080; // diese Breite muss das Fenster haben, damit pinnen usw
    private animationSpeedMS: number = 500;
    private animationDelayMS: number = 200;

    private _onClick_UserInfo(evt: MouseEvent) {
        evt.stopPropagation();

        if (this.isOpened != true) {
            evt.preventDefault();
            this._onClick_menu(evt);
        }
    }

    private _onClick_Link(link: Sidebar.LinkEntry, evt: MouseEvent) {
        if (link == this.getSelectedLink()) {

        } else {
            this.UiModder.domClass.add(this.domNode, "clicked");
            this.UiModder.domClass.add(link.node, "clicked");
            setTimeout(lang.hitch(this, this.UiModder.domClass.remove, link.node, "clicked"), 5000);
            setTimeout(lang.hitch(this, this.UiModder.domClass.remove, this.domNode, "clicked"), 4500);
            evt.stopPropagation();
        }
    }

    private _onClick_Profile(evt: MouseEvent) {
        // mittlere Maustaste

        location.href = window.appRoot + "home/login";
    }
    private _onClick_Logout(evt: MouseEvent) {

        let sessionInfo = window.sessionInfo;

        if (!sessionInfo) return;

        sessionInfo.closeSession();

        this.disableNode(this.logoutContainer);
        this.disableNode(this.menuContainer);

        //    this.UiModder.domClass.add(document.body, "mds-fade");
        //    setTimeout(lang.hitch(this, this.UiModder.domClass.add, document.body, "hidden"), 100);


        //    let sessionID = sessionInfo.sessionData.Session.Id;

        //    this.RequestManager.post(window.appRoot + "session/close",
        //        {
        //            "sessionid": sessionID
        //        },
        //        lang.hitch(this, this._onCloseSessionResponse),
        //        lang.hitch(this, this._onCloseSessionError)
        //    );
    }

    private _onCloseSessionResponse(response) {
        topic.publish("/Session/Close", null);

        setTimeout(lang.hitch(this, function () {
            location.reload();
        }), 500);
    }

    private _onCloseSessionError(error: more.requestErrorMessage) {

        this.UiModder.domClass.remove(document.body, "hidden");
        console.error("_onCloseSessionError", error);
        alert(error.Message);

        this.openSidebar();
        this.disableNode(this.menuContainer, false);
        this.disableNode(this.logoutContainer, false);
    }

    private releaseSession() {
        let url = window.appRoot + "management/ReleaseAllPitSessions";
        this.RequestManager.post(
            url,
            {

            },
            lang.hitch(this, function (response: any) {
                if (response == "true" || response == true) {
                    if (confirm("success! update userroles?") == true) {
                        topic.publish("/Session/UpdateUserroles");
                        ToasterHelpers.showToast({
                            title: "Updating may take a few seconds...",
                            ID: "/Session/UpdateUserroles",
                            iconClass: ToasterHelpers.ToasterIcons.hourglass,
                            timeout: 60 * 1000
                        });
                    }
                    return;
                }
                alert(response);
            }),
            lang.hitch(this, function (error: more.requestErrorMessage) { alert(error.Message); }),
            false // sync
        );
    }

    private mouseEnterTimeout: number = null;

    _onClick_Expander(evt: MouseEvent) {
        evt.stopPropagation();
        if (this._isToggling) return;

        if (this.mouseEnterTimeout) clearTimeout(this.mouseEnterTimeout);

        this.toggleOpen(!this.isOpened, true);
    }
    private _onClick_Sidebar(evt: MouseEvent) {
        if (this.isOpened) return;
        if (this.mouseEnterTimeout) clearTimeout(this.mouseEnterTimeout);

        this.toggleOpen(true, false);
    }
    private _onClick_Overlay(evt: MouseEvent) {
        if (this.isOpened && !this._isSidebarPinned) {
            this.toggleOpen(false);
        }
    }
    private _onMouseEnter_Overlay(evt: MouseEvent) {

    }
    private _onMouseEnter_Sidebar(evt: MouseEvent, timeout: number = 300) {

        if (this.mouseEnterTimeout) clearTimeout(this.mouseEnterTimeout);

        if (this.isOpened) return;
        if (this._isSidebarPinned) return;

        this.mouseEnterTimeout = setTimeout(lang.hitch(this, this.toggleOpen, true), timeout);
    }

    private _onMouseLeave_Sidebar(evt: MouseEvent, timeout: number = 800) {
        if (this.mouseEnterTimeout) clearTimeout(this.mouseEnterTimeout);
        if (!this.isOpened) return;
        if (this._isSidebarPinned) return;



        this.mouseEnterTimeout = setTimeout(lang.hitch(this, this.toggleOpen, false), timeout);

    }

    private _onFocus_Sidebar(evt: Event) {

    }

    private _onBlur_Sidebar(evt: Event) {

    }


    private _onClick_PinSidebar() {
        this.pinSidebar(!this._isSidebarPinned);
    }

    private _onContentNodeClick() {

        if (this._isSidebarPinned === false) {

            this.closeSidebar();
        }


    }

    openSidebar() {
        this.toggleOpen(true);
    }

    closeSidebar() {
        this.toggleOpen(false);
    }

    private _isToggling: boolean = false;
    toggleOpen(targetState?: boolean, saveToStorage?: boolean) {

        //console.debug("open sidebar - target, current", targetState, this.isOpened);

        if (targetState == this.isOpened && saveToStorage != true && this._isPinningChange != true) {
            // trotzdem einmal aktualisieren, falls wir beim ersten Seitenladen hier landen:
            domClass.toggle(this.domNode, "collapsed", !this.isOpened);
            domClass.toggle(this.domNode, "expanded", this.isOpened);

            document.documentElement.style.setProperty("--sidebarWidth", !this.isPinned ? this.collapsedWidth : this.isOpened ? this.sidebarWidth : this.collapsedWidth);

            return;
        }

        if (targetState !== true && targetState !== false) {
            targetState = !this.isOpened;
        }

        let mainContent = this.mainContentNode;
        //let overlay = this.sidebarOverlay; // document.getElementById("darkenOverlay");

        if (this.isOpened && !targetState) {
            domClass.add(this.domNode, "collapsing");
            setTimeout(lang.hitch(this, this.UiModder.domClass.remove, this.domNode, "show collapsing"), this.animationSpeedMS - 100);

        } else if (!this.isOpened && targetState) {
            domClass.toggle(this.domNode, "show opening", targetState);
            setTimeout(lang.hitch(this, this.UiModder.domClass.remove, this.domNode, "opening"), 5);
        }

        this._isToggling = true;

        if (targetState == true) {

            //domClass.toggle(this.domNode, "w3-sidebar", !this._isSidebarPinned);

            if (this._isSidebarPinned) {
                if (mainContent && (this.isOpened != targetState || this._isPinningChange)) {
                    let width = this.sidebarWidth;

                    this.applyPaddingToMainContent(width);

                    this._isPinningChange = false;
                }
            } else {
                let width = this.collapsedWidth;
                this.applyPaddingToMainContent(width);
            }

            document.documentElement.style.setProperty("--sidebarWidth", !this._isSidebarPinned ? this.collapsedWidth : this.sidebarWidth);


            topic.publish("sidebar/opened", {
                sidebarWidth: this.sidebarWidth, // string mit "px" am ende
            });

            // Kompatibilität mit altem Webkalender:
            topic.publish("layout/navBar_opening", {
                sidebarWidth: this.sidebarWidth, // string mit "px" am ende
            });
        }
        else {

            if (mainContent) {
                this.applyPaddingToMainContent(this.collapsedWidth);
            }

            document.documentElement.style.setProperty("--sidebarWidth", this.collapsedWidth);

            topic.publish("sidebar/closed");
            topic.publish("layout/navBar_closing"); // Kompatibilität mit altem Webkalender
        }

        this.isOpened = targetState;


        this.UiModder.domClass.toggle(document.body, "sidebarOpened", this.isOpened);


        domClass.toggle(this.domNode, "expanded", this.isOpened);
        domClass.toggle(this.domNode, "collapsed", !this.isOpened);

        setTimeout(lang.hitch(this, function () { this._isToggling = false; }), this.animationSpeedMS);

        this._updateCollapsedSubentryStyles();

        if (saveToStorage !== false) {
            let saveData = { "sidebarPinned": this._isSidebarPinned, "sidebarOpen": this.isOpened };
            localStorage.setItem("ego_dynamicSidebar", JSON.stringify(saveData));
        }

        //console.debug("sidebar toggleopen", targetValue, this.isOpened);
    }

    private applyPaddingToMainContent(extraPadding: string) {

        if (extraPadding == null) {
            //domStyle.set(this.mainContentNode, "paddingLeft", null);
            this.mainContentNode.style.removeProperty("--extraPadding");
            this.mainContentNode.style.removeProperty("--extraPadding");
            return;
        }

        this.currentExtraPadding = extraPadding;
        this.currentMainContentPadding = "calc(" + extraPadding + " + " + this._initialMainContentPadding + ")";

        //console.debug(this.id + " applyPaddingToMainContent", this.currentMainContentPadding);

        this.mainContentNode.style.setProperty("--w3AnimationDuration", this.animationSpeedMS + "ms");
        domClass.add(this.mainContentNode, "egoAnimatedPadding");

        //domStyle.set(this.mainContentNode, "paddingLeft", this.currentMainContentPadding);
        this.mainContentNode.style.setProperty("--currentPadding", this.currentMainContentPadding);
        this.mainContentNode.style.setProperty("--extraPadding", extraPadding);

        setTimeout(lang.hitch(this, this._removeAnimationFromMainContent), this.animationSpeedMS + 10);

    }

    private _removeAnimationFromMainContent() {
        let mainContent = document.getElementById("mainContent");

        domClass.remove(mainContent, "egoAnimatedPadding");
        mainContent.style.removeProperty("--w3AnimationDuration");
    }

    _setLangSelectVisibleAttr(value: boolean) {
        this.langSelectVisible = value;


    }

    private pinTarget: boolean = null;
    private tryPinSidebar(bDoPin: boolean, changeState?: boolean) {
        if (bDoPin !== true && bDoPin !== false) bDoPin = true;

        if (bDoPin == true) {
            if (window.innerWidth < this.responsiveThresholdPX) {
                return;
            }
        }

        this.pinSidebar(bDoPin, changeState);
    }
    private pinSidebar(bDoPin: boolean, changeState?: boolean) {
        if (!this._isInitialized) {
            this.pinTarget = bDoPin;
            return;
        }
        if (bDoPin === false) {

        } else {
            bDoPin = true;
        }

        if (this._isSidebarPinned != bDoPin) {
            this._isPinningChange = true;
        }
        this._isSidebarPinned = bDoPin;

        if (this._isSidebarPinned == false) {
            domClass.remove(this.domNode, "pinned");
            this.toggleOpen(this.isOpened, false);
        } else {
            domClass.add(this.domNode, "pinned");

            if (changeState !== false) {
                this.openSidebar();
            }
        }

        this.isPinned = this._isSidebarPinned;

        //domClass.toggle(this.iconPin, "fa-thumbtack", this.isPinned);
        //domClass.toggle(this.iconPin, "fa-thumbtack-slash", !this.isPinned); // das Icon gibts erst ab fa6, also in legacy-Styles nicht da... Erkennung schwierig
        domClass.toggle(this.iconPin, "w3-opacity fa-rotate-20", !this.isPinned); // mach mas inzwischen so.

        this._isPinningChange = false;
    }

    private _onSessionLoading(isLoading: boolean) {
        // Ladeanimation bei Login
        //var topUserInfoNode = document.getElementById("top_login_info");

        //if (topUserInfoNode) {
        //    domClass.toggle(topUserInfoNode, "loading egoAnimated_fadingHourglassOverlay", isLoading === true);
        //    domClass.toggle(topUserInfoNode, "w3-hide", isLoading !== true && !window.sessionInfo?.sessionData);
        //}

        domClass.toggle(this.userInfoContainer, "loading egoAnimated_fadingHourglassOverlay", isLoading === true);
        domClass.toggle(this.userInfoContainer, "w3-hide", isLoading !== true && !window.sessionInfo?.sessionData);
    }

    private checkForExistingSession() {

        let data = window.sessionInfo?.sessionData;

        //console.debug("Sidebar checkForExistingSession", data);

        if (data) {
            this._onCheckForExistingSessionResult(data);
        } else {

        }

    }
    private _onClosingSession() {
        setTimeout(lang.hitch(this, this.toggleOpen, false, false), 10);

        //this._onCheckForExistingSessionResult();
    }
    private _onCheckForExistingSessionResult(response?) {

        let isSession = window.sessionInfo?.isSessionOpen();

        //console.debug("Sidebar existing session, session? opened?", isSession, this.isOpened);

        if (this._sessionLogoutHandle) clearTimeout(this._sessionLogoutHandle);

        if (!this._isInitialized) return;

        if (isSession) {
            let sessionData = window.sessionInfo.sessionData;
            if (sessionData.IsTwoFactorAuthMandatory == true && sessionData.IsTwoFactorAuthEnabled != true) {
                // wir sind auf der 2FA-Setupseite, weil es Mandatory ist. Sidebar wegblenden:
                if (location.pathname.toLowerCase().indexOf("/home/twofactorauthentication") != -1) {
                    setTimeout(lang.hitch(this, this.destroy), 1000);
                    return;
                }
            }

            let strData = localStorage.getItem("ego_dynamicSidebar");
            this.readInitialMainContentPadding();
            let data = null;
            try {
                if (strData) {
                    data = JSON.parse(strData);
                }
                else {
                    data = {
                        sidebarPinned: true,
                        sidebarOpen: true
                    }
                }
            } catch (ex) {

            }

            this.hideNode(this.domNode, false);

            if (data) {

                if (data.sidebarPinned === true || data.sidebarPinned === false) {
                    this.pinSidebar(data.sidebarPinned && window.innerWidth > this.responsiveThresholdPX, false);
                }

                if ((data.sidebarOpen === true || data.sidebarOpen === false) && this._isSidebarPinned === true) {
                    this.toggleOpen(data.sidebarOpen, false);
                }

                if (!this.isOpened) this.applyPaddingToMainContent(this.collapsedWidth);
            }
            else {
                this.closeSidebar();
            }
        } else {
            this.toggleOpen(false, false);

            this._sessionLogoutHandle = setTimeout(lang.hitch(this, this._execLogoutAnimation), 200);
            this.drawLinks(null);
        }

        this._updateStyles();

    }

    private _sessionLogoutHandle: number = null;
    private _execLogoutAnimation() {
        //    this.UiModder.domClass.add(this.domNode, "mds-fade");
        //    setTimeout(lang.hitch(this, this.UiModder.domClass.add, this.domNode, "hidden"), this.animationSpeedMS);
        //    setTimeout(lang.hitch(this, this.UiModder.domClass.remove, this.domNode, "mds-fade"), this.animationSpeedMS + this.animationDelayMS);
        //    setTimeout(lang.hitch(this, this.applyPaddingToMainContent, "0px"), 50);
    }

    private _onSubstitutionsAvailable(data: Array<any>) {
        //this._prepareMenuEntries();
        this._updateStyles();
    }

    private _prepareMenuEntries() {
        this._availableMenuEntries = [];

        if (this.hasUserRole("_DEV")) {
            //this._availableMenuEntries.push({
            //    callback: lang.hitch(this, this._onClick_ThemeToggleApril1st),
            //    label: "1. April",
            //    icon: "fas fa-smile-wink",
            //    groupname: "DEV",
            //    heading: "DEV"
            //});


            this._availableMenuEntries.push({
                callback: lang.hitch(this, function () {
                    let dlg = new GenericDialog();
                    let container = domConstruct.create("div", { innerHTML:/* JSON.stringify(window.customerSettings, null, 2)*/""});
                    dlg.show(container, "Features / Module", null, null, "close");

                    try {
                        let index = -1;
                        let sorted = window.customerSettings.modules.sort((a, b) => { return a.name.localeCompare(b.name); })
                        for (let module of sorted) {
                            index++;
                            let exp = new ExpandableSection();
                            let content = domConstruct.create("div", {});
                            exp.setup(content, module.name, "small");
                            exp.placeAt(container);
                            let count = 0;

                            exp.domNode.classList.add("w3-section");

                            if (module.features?.length) {
                                for (let feature of module.features) {
                                    let line = domConstruct.create("div", {
                                        className: "w3-small",
                                        innerHTML: feature
                                    }, content);

                                    if (feature.indexOf("#") != 0) {
                                        count++;
                                    } else {
                                        line.classList.add("w3-opacity");
                                    }

                                //    on(line, "click", lang.hitch(this, function (moduleIndex: string, feature: string, element: HTMLElement) {
                                //        let plainFeatureString = feature.replace("#", "");
                                //        feature = plainFeatureString;
                                //        let arr = window.customerSettings.modules[moduleIndex].features;
                                //        let index = arr.indexOf(plainFeatureString);
                                //        if (index == -1) {
                                //            index = arr.indexOf("#" + plainFeatureString);
                                //            feature = "#" + plainFeatureString;
                                //        }
                                //        if (index != -1) {
                                //            domClass.toggle(line, "w3-opacity");
                                //            let targetState = feature.indexOf("#") == 0;
                                //            if (!targetState) plainFeatureString = "#" + plainFeatureString;
                                //            if (index != -1) {
                                //                arr[index] = plainFeatureString;
                                //                line.innerHTML = plainFeatureString;
                                //            }
                                //        }
                                //    }, index, feature, line))
                                }
                            }

                            if (module.name.indexOf("#") == 0) {
                                // "deaktiviert"
                                exp.setMarking(ExpandableSectionMarkings.empty);
                            }

                            exp.setCounter(count, null);

                            let pagestack: MdsLax<InstanceType<typeof PageStack>> = null;
                            for (let prop in module) {
                                switch (prop.toLowerCase()) {
                                    case "name":
                                    case "features":

                                        break;

                                    case "version":
                                        let version = module["version"] as number;
                                        if (typeof (version) == "number") {
                                            exp.setHeading(module.name + " " + version.toFixed(4));
                                        }
                                        break;

                                    default:
                                        if (!pagestack) {
                                            pagestack = new PageStack();
                                            pagestack.placeAt(content);

                                            exp.addIconToExpander("fas fa-cogs");
                                        }

                                        let unknownValue = module[prop];
                                        if (!unknownValue) {

                                        }
                                        else if (typeof (unknownValue) == "object") {
                                            unknownValue = JSON.stringify(unknownValue, null, 2);
                                        }
                                        else if (unknownValue.toString) {
                                            unknownValue = unknownValue.toString();
                                        }
                                        let pre = domConstruct.create("pre", {
                                            className: "w3-small",
                                            innerHTML: unknownValue
                                        });
                                        
                                        let page = pagestack.addPage(pre, {
                                            label: prop,
                                            name: prop
                                        });

                                        break;
                                }
                            }
                        }
                    } catch (ex) {
                        container.innerHTML = "error parsing customersettings<br>" + ex + "<br>" + JSON.stringify(window.customerSettings, null, 2);

                    }

                }),
                label: "Features",
                icon: "fas fa-shapes",
                groupname: "DEV",
                heading: "DEV"
            });

            if (window["ToggleCustomStyle"]) {
                /*
                TOM:
                ich möchte diese farbkleckse nie wieder sehen... ein ganz dezentens orange zu differenzierung wäre ok
                danke 
                */
                if (this.getCurrentUserName() == "rL") {
                this._availableMenuEntries.push({
                    callback: lang.hitch(this, this._onClick_ToggleBaseCSS),
                    label: "base CSS",
                    icon: "fas fa-swatchbook",
                    groupname: "DEV",
                    heading: "DEV"
                });
                }
            }

            this._availableMenuEntries.push({
                callback: lang.hitch(this, this._onClick_ThemeToggle),
                label: "Darkmode",
                icon: "fas fa-moon",
                groupname: "DEV",
                heading: "DEV"
            });

            this._availableMenuEntries.push({
                callback: lang.hitch(this, this.releaseSession),
                label: "Sessions freigeben",
                icon: "fas fa-unlink",
                groupname: "DEV",
                heading: "DEV",
                coloration: "mds-orange"

            });
        }

        if (this.hasFeature("System/lightmode") && this.hasFeature("system/darkmode")) {

            if (window.themeToggler.isDarkTheme()) {
                this._availableMenuEntries.push({
                    callback: lang.hitch(this, this._onClick_ThemeToggle),
                    label: this.canTranslate("Theme_Lightmode") ? this.translate("Theme_Lightmode") : "Lightmode",
                    icon: "fas fa-sun"
                })
            } else {
                this._availableMenuEntries.push({
                    callback: lang.hitch(this, this._onClick_ThemeToggle),
                    label: this.canTranslate("Theme_Darkmode") ? this.translate("Theme_Darkmode") : "Darkmode",
                    icon: "fas fa-moon"
                })
            }

        }

        if (this.hasFeature("system/enableUserSubstitution") && window.sessionInfo.isSessionOpen()) {

            if (window.sessionInfo.getAvailableUserSubstitutionCount() > 0) {
                this._availableMenuEntries.push({
                    callback: lang.hitch(this, this._onClick_UserSubstitution),
                    label: "Sidebar__BtnSelectSubstituteLabel",
                    icon: "fas fa-user fa-mds-user-substitution"
                });
            } else if (window.sessionInfo.isSubstitutionActive()) {
                this._availableMenuEntries.push({
                    callback: lang.hitch(this, this._onClick_UserSubstitution),
                    label: "Sidebar__RemoveSubstituteLabel",
                    icon: "fas fa-user fa-mds-user-substitution"
                });
            }
        }

        if (this._availableMenuEntries.length > 0) {
            this._availableMenuEntries.push({
                callback: lang.hitch(this, this._onClick_Profile),
                label: this.translate("Sidebar__Userprofile"),
                icon: "fas fa-user-circle"
            });

            this._availableMenuEntries.push({
                callback: lang.hitch(this, this._onClick_Logout),
                label: this.translate("LoginForm__Logout"),
                icon: "fas fa-sign-out-alt"
            });
        }
    }
    private _updateStyles() {

        let isSession = window.sessionInfo?.isSessionOpen();
        let userName = window.sessionInfo?.getUserName();
        let userDisplay = window.sessionInfo?.getUserDisplayName();
        let sessionData = window.sessionInfo?.sessionData;
        let employeeId = window.sessionInfo?.getCurrentEmployeeId();

        let actualUserName = window.sessionInfo?.getUserName(true);
        let actualUserDisplay = window.sessionInfo?.getUserDisplayName(true);
        let actualEmployeeId = window.sessionInfo?.getCurrentEmployeeId(true);
        let isSubstitute = window.sessionInfo?.isSubstitutionActive();

        let userNameNode = document.getElementById("top_Username");

        this.setProfilePic(null);

        if (!isSession) {
            this.hideNode(this.logoutContainer, !isSession);
            this.hideNode(this.menuContainer, !isSession);
        } else {
            this._prepareMenuEntries();

            this.hideNode(this.logoutContainer, this._availableMenuEntries.length > 0);
            this.hideNode(this.menuContainer, this._availableMenuEntries.length == 0);
        }

        if (userNameNode != null) {
            this.UiModder.domAttr.set(userNameNode, "innerHTML", "");
        }

        if (isSession === true) {

            this.UiModder.domAttr.set(this.username, "innerHTML", actualUserName);

            window.sessionInfo.getProfilepicData(lang.hitch(this, this.setProfilePic));

            if (actualUserDisplay != actualUserName) {

                this.UiModder.domAttr.set(this.userDisplayname, "innerHTML", actualUserDisplay);
            }

            //domClass.remove(this.substituteContainer, "w3-hide");

            if (userNameNode != null) {
                this.UiModder.domAttr.set(userNameNode, "innerHTML",
                    this.stringFormat(
                        "<b>{1}</b>",
                        this.translate("Sidebar__UserdisplayPrefix"),
                        actualUserDisplay
                    )
                );
            }

            this.UiModder.domAttr.set(this.substUsername, "innerHTML", userName);
            this.UiModder.domAttr.set(this.substituteDisplayname, "innerHTML", userDisplay);
            this.hideNode(this.substituteUsernameContainer, !isSubstitute);
            this.UiModder.domClass.toggle(this.domNode, "subsitutionActive", isSubstitute);
            if (isSubstitute === true) {

            }

        } else {
            this.UiModder.domAttr.set(this.username, "innerHTML", "");
            this.UiModder.domAttr.set(this.userDisplayname, "innerHTML", "");
        }

        this.hideNode(this.userInfoContainer, !isSession);

    }

    private _onCheckForExistingSessionError(error) {

    }

    private _currentSession: MdsLax<InstanceType<typeof SessionInfo>>;
    private _currentSessionId: string;
    private _onRolesUpdated(result) {
        // sollte nur hierherkommen, wenns auch wirklich ein Update gab. falls result doch false, abfangen:
        if (result) {
            this._onSessionChange(true);
        }
    }
    private _onSessionChange(bForceUpdate?: boolean) {
        //console.debug(this.id + " sessionChange", window.sessionInfo, this._currentSession);
        //setTimeout(lang.hitch(this, this.readInitialMainContentPadding), 2000);

        if (bForceUpdate !== true) {
            if (this._currentSession?.sessionData && window.sessionInfo?.sessionData) {
                if (this._currentSessionId == window.sessionInfo.sessionData.Session.Id) {
                    return;
                }
            }
        }
        if (!this._currentSession?.sessionData && !window.sessionInfo?.sessionData) return;

        //console.debug(this.id + " sessionChange - actual change!", window.sessionInfo, this._currentSession);
        if (this._currentSessionId != window.sessionInfo.sessionData.Session.Id) {
            this._currentSession = window.sessionInfo;
            this._currentSessionId = window.sessionInfo.sessionData.Session.Id;

            this._onCheckForExistingSessionResult(window.sessionInfo);
        }
        if (window.sessionInfo?.sessionData != null) {
            if (window.sessionInfo.sessionData.IsTwoFactorAuthEnabled == true &&
                window.sessionInfo.sessionData.IsValidTwoFactorAuthentication !== true) {

                return;
            }

            // Cache im Localstorage prüfen!
            let cacheStr = localStorage.getItem("ego_SidebarLinks");

            if (cacheStr) {
                try {

                    let data: SidebarLinkCache = JSON.parse(cacheStr);
                    if (data.sessionId == this._currentSessionId) {
                        let currentRolesHash = StringHelpers.hashMD5(this._currentSession.getRoles().join("|"));
                        if (data.rolesHash == currentRolesHash) {
                            let currentLang = window.currentLanguageCode;
                            if (data.sidebarLinks?.length && data.language == currentLang) {
                                this.drawLinks(data.sidebarLinks);
                                return;
                            }
                        }
                    }
                } catch (ex) {
                }
            }
            // sidebar muss request machen um die links zu bekommen...
            this.loadLinks();
        } else {
            //this._initLinks();
        }
    }

    private loadLinks() {

        let jsonData = "{}";

        this.hourGlassStart(this.scrollingContainer)

        this.RequestManager.post(
            window.appRoot + "Navigation/GetSidebarLinks",
            {
                "jsonData": jsonData
            },
            lang.hitch(this, this._onLoadLinksResponse),
            lang.hitch(this, this._onLoadLinksError));
    }

    private _onLoadLinksResponse(response: { sidebarLinks: Array<Sidebar.Link> }) {
        //console.debug("Sidebarlinks loaded", response);
        this.drawLinks(lang.clone(response.sidebarLinks));

        this.hourGlassEnd(this.scrollingContainer);

        // cachen!
        try {
            let data: SidebarLinkCache = {
                rolesHash: StringHelpers.hashMD5(this._currentSession.getRoles().join("|")),
                sessionId: this._currentSessionId,
                sidebarLinks: response.sidebarLinks,
                language: window.currentLanguageCode
            };

            localStorage.setItem("ego_SidebarLinks", JSON.stringify(data));
        } catch (ex) {
            console.warn("Caching of sidebar links failed", ex);
        }
    }

    private _onLoadLinksError(error) {
        console.error("Sidebarlinks loading error", error.Message);

        setTimeout(lang.hitch(this, this.loadLinks), 5000);
    }

    private setProfilePic(data): void {

        //if (data) {
        //    console.debug("sidebar setprofilpic", data.checksum);
        //}

        let topUserIcon = document.getElementById("top_login_avatar_placeholder");

        if (topUserIcon) {
            domConstruct.empty(topUserIcon);
        }

        if (this.userPic) {
            this.UiModder.domClass.add(this.userPic, "w3-hide");
            this.UiModder.domAttr.set(this.userPic, "src", "");
        }

        //console.debug("setProfilePic", data, topUserIcon);

        if (data) {
            if (topUserIcon && data.base64) {
                let picOverlay = domConstruct.create("img", {
                    "src": "data:image/jpeg;base64," + data.base64,
                    "className": "profilePic round"
                }, topUserIcon);
            }

            if (this.userPic && data.base64) {
                this.UiModder.domAttr.set(this.userPic, "src", "data: image/jpeg; base64, " + data.base64);
                this.UiModder.domClass.remove(this.userPic, "w3-hide");
            }
        }
    }

    private getSubEntryByName(name) {
        let currentSelect = this.getSelectedLink();
        if (!currentSelect) return null;

        for (let entry of currentSelect.subEntries) {
            if (entry.name == name) {
                return entry;
            }
        }

        return null;
    }

    changeSubentryName(name: string, newName: string) {
        let subEntry = this.getSubEntryByName(name);
        if (!subEntry) return;
        subEntry.name = newName;
    }

    addEntryToCurrentNavigation(descriptor: Sidebar.SubLink) {
        let currentSelect = this.getSelectedLink();
        if (currentSelect && descriptor) {
            let existingEntry = this.getSubEntryByName(descriptor.name);
            if (existingEntry) return;

            let subEntry: Sidebar.SubLinkEntry = {
                ...descriptor,
                enableClosing: false,
                labelNode: null,
                node: null
                //collapsedNode: null
            };

            subEntry.node = domConstruct.create("div", {
                className: "subEntry round fadeOnCollapse"
            }, currentSelect.subEntryNode);

            let subLink = domConstruct.create("a", {
                innerHTML: descriptor.label, className: "link hoverDark",
            }, subEntry.node);
            subEntry.labelNode = subLink;

            //let CollapsedSubLink = domConstruct.create("button", {
            //    innerHTML: "",
            //    className: "mds-button-base collapsedSubEntry showOnCollapse",
            //}, currentSelect.subEntryNode);
            //subEntry.collapsedNode = CollapsedSubLink;


            if (descriptor.enableClosing) {
                let closeBtn = domConstruct.create("button", {
                    className: "buttonBase transparentBtn",
                    id: "closeBtn",
                    innerHTML: this.createFontawesomeIcon("fas fa-times sbCloseSub").outerHTML
                }, subEntry.node);
                closeBtn.setAttribute("data-cy", "sidebar:close:" + descriptor.name);
                on(closeBtn, "click", lang.hitch(this, this._onRequestCloseSubEntry, subEntry));
            }

            //let iconclass = "fas fa-angle-right";
            let iconclass = null;// "fas fa-angle-right";
            if (descriptor.iconclass) {
                iconclass = descriptor.iconclass;
            }
            if (iconclass) {
                let icon = this.createFontawesomeIcon(iconclass, "&nbsp;");
                domConstruct.place(icon, subEntry.labelNode, "first");
            }

            if (descriptor.color) {
                subEntry.node.style.setProperty("--linkColor", descriptor.color);
            }

            on(subEntry.node, "click", lang.hitch(this, this._onClick_SubEntry, descriptor.name, descriptor.callback));

            currentSelect.subEntries.push(subEntry);
            this._updateCollapsedSubentryStyles(currentSelect);

            return subEntry;
        }

        return null;
    }

    private _updateCollapsedSubentryStyles(link?: Sidebar.LinkEntry) {
        if (!link) link = this.getSelectedLink();
        if (!link) return;

        this.hideNode(link.subEntryNode, link.subEntries.length == 0);
        //console.debug("_updateCollapsedSubentryStyles", link.subEntryNode);
        let previousHeight = link.subEntryNode.clientHeight;

        if (this.isOpened) {
            link.subEntryNode.style.setProperty("--currentHeight", "unset");
            let height = link.subEntryNode.clientHeight;

            link.subEntryNode.style.setProperty("--currentHeight", previousHeight + "px");

            setTimeout(lang.partial(function (height) {
                link.subEntryNode.style.setProperty("--currentHeight", height + "px");
            }, height), this.animationDelayMS);

        } else {

        }

        //let count = link.subEntries?.length; // so wills der Chef nicht
        // let count = link.subEntries?.filter(sub => (sub.enableClosing == true)).length; // sondern so

        //this.UiModder.domAttr.set(link.iconContainer, "data-subentryCount", count.toString());
        //this.UiModder.domClass.toggle(link.node, "hasSubentries", link.subEntries.length > 0);
        // aber es macht wenig Sinn den Zähler jetz willkürlich an irgendeiner Eigenschaft festzumachen, das checkt ja keiner mehr
    }

    private _onRequestCloseSubEntry(subEntry, evt: MouseEvent) {
        //Event muss spezifisch übergeben werden da es sonst auf dem Weg verloren geht
        this.emit("requestClose", subEntry, [evt] );
    }

    removeSubentryByName(targetName) {
        let currentSelect = this.getSelectedLink();
        if (!currentSelect) {
            return false;
        }
        for (let i = 0; i < currentSelect.subEntries.length; i++) {
            let entry = currentSelect.subEntries[i];
            if (entry.name == targetName) {
                domConstruct.destroy(entry.node);
                currentSelect.subEntries.splice(i, 1);

                this._updateCollapsedSubentryStyles(currentSelect);

                return true;
            }
        }
        return false;
    }

    renameSubentryLabel(targetName, newName) {
        let subEntry = this.getSubEntryByName(targetName);
        if (subEntry) {
            this.UiModder.domAttr.set(subEntry.labelNode, "innerHTML", newName);
        }
        return true;
    }

    private activateSubentryByName(targetName) {
        let currentSelect = this.getSelectedLink();
        if (!currentSelect) {
            return;
        }
        for (let entry of currentSelect.subEntries) {
            if (entry.name == targetName) {
                domClass.add(entry.node, "selected");
                entry.node.scrollIntoView({ behavior: "smooth", block: "nearest" });
            }
            else {
                domClass.remove(entry.node, "selected");
            }
        }
    }

    private _onClick_SubEntry(name, callback, evt) {
        this.activateSubentryByName(name);
        if (typeof (callback) == "function") {
            callback();
        }
    }


    private drawLinks(newLinks?: Array<Sidebar.Link>) { // und wo ist initRechts?? HAHAHAHA

        if (!window.sessionInfo) {
            return;
        }


        if (this.sidebarLinkRegistry) {
            for (let i = 0; i < this.sidebarLinkRegistry.length; i++) {
                if (this.sidebarLinkRegistry[i].node != null && typeof (this.sidebarLinkRegistry[i].node) != "undefined") {
                    domConstruct.destroy(this.sidebarLinkRegistry[i].node);
                    this.sidebarLinkRegistry[i].node = null;
                }
            }
        }

        this.sidebarLinkRegistry = [];

        domConstruct.empty(this.topContainer);

        if (!newLinks || !newLinks.length) return;

        //console.debug("sidebar initLinks", isSession, roles, this.sidebarLinks);

        for (let link of newLinks) {
            let entry = this.addLink(link);
            this.sidebarLinkRegistry.push(entry);
        }

        let selectedLink = this.getSelectedLink();
        if (selectedLink) {
            domClass.add(selectedLink.node, "selected");
            selectedLink.node.scrollIntoView({ behavior: "smooth", "block": "nearest" });
        }

        //console.debug("sidebar links after init", this.sidebarLinks);

        topic.publish("sidebar/linksCreated", this.sidebarLinkRegistry);
    }

    addLink(descriptor: Sidebar.Link): Sidebar.LinkEntry {
        let isSession = window.sessionInfo.isSessionOpen();

        let displayLink = false;

        let link = descriptor as Sidebar.LinkEntry;

        link.subEntries = [];

        let bHasNode = link.node != null && typeof (link.node) != "undefined";

        //console.debug("sidebar displaylink", link, isSession, roles);

        // braucht keine Rolle?
        if (link.role == "" || link.role == null || typeof (link.role) == "undefined") { // LEGACY
            displayLink = true;
        }
        // wenn doch: Rolle vorhanden?
        else {
            displayLink = this.hasUserRole(link.role);
        }

        // nur anzeigen wenn keine Session offen?
        if (isSession != false && link.noSessionOnly === true) {
            displayLink = false;
        }

        // nur anzeigen wenn Session offen?
        if (isSession == false && link.SessionOnly === true) {
            displayLink = false;
        }

        //console.debug("sidebar initLink " + link.text, "session?", isSession, "node?", bHasNode, "Display?", displayLink, link.element);

        // Linknode schon vorhanden und muss weg?
        if (bHasNode === true && displayLink != true) {

            domConstruct.destroy(link.node);
            link.node = null;

        } else if (displayLink === true && bHasNode != true) {

            let label = link.label;
            if (typeof (link.label) == "undefined") {
                label = link["text"]; // LEGACY
                link.label = label;
            }
            let itemContainer = domConstruct.create("div", {
                className: "item"
            }, this.topContainer);

            let linkItem = domConstruct.create("a", {
                className: "link hoverDark"
            }, itemContainer);
            on(linkItem, "click", lang.hitch(this, this._onClick_Link, link));


            let iconcontainer = domConstruct.create("div", {
                className: "sbIcon",
                title: label
            }, linkItem);

            link.iconContainer = iconcontainer;

            let iconclass = "fas fa-caret-right";
            if (link.iconclass) {
                iconclass = link.iconclass;
            }

            if (iconclass) {
                let colorclass = "";
                let colorStyle = {};
                let linkIcon = this.createFontawesomeIcon(iconclass + " " + colorclass + " ", "", link.iconContainer);
            }

            let linkLabel = domConstruct.create("div", {
                innerHTML: label,
                className: "label"
            }, linkItem);


            if (typeof (link.target) != "undefined") {
                link.url = window.appRoot + link.target;
                this.UiModder.domAttr.set(linkItem, "href", link.url);
                linkItem.setAttribute("data-cy", "sidebarItem:" + link.target);
            }


            //link.subselectorContainer = domConstruct.create("div", {
            //    className: "modal subentryContainer w3-hide"
            //}, itemContainer, "last");

            link.node = linkItem;

            link.subEntryNode = domConstruct.create("div", {
                className: "subentryContainer w3-hide"
            }, itemContainer, "last");

        }

        return link;
    }


    private isLinkSelected(link: Sidebar.LinkEntry | string): boolean {

        let url = "";
        if (typeof (link) == "string") {
            url = link;
        } else {
            url = link.url;
        }
        let bMatch = location.pathname.toLowerCase() == url.toLowerCase();
        if (bMatch) return true;

        let parts = url.split("?");
        if (parts.length > 1) {
            return this.isLinkSelected(parts[0]);
        }

        return false;
    }

    getSelectedLink(): Sidebar.LinkEntry {
        for (let link of this.sidebarLinkRegistry) {
            if (this.isLinkSelected(link)) {
                return link;
            }
        }

        return null;
    }

    getSelectedSectionTitle() {
        let link = this.getSelectedLink();
        if (link) {
            return link.label;
        }

        return null;
    }

    postMixInProperties() {
        super.postMixInProperties.apply(this, arguments as any); // standard code aus basisklasse
    }

    postCreate(): void {
        super.postCreate.apply(this, arguments as any);

        let bFeature = this.hasFeature("System/UserProfilePic");
        if (!bFeature) {
            this.UiModder.domClass.replace(this.avatarPlaceholderIcon, "fa-user", "fa-user-circle");
        }

        window["lytSidebar"] = this;
        (window as any)["sidebar"] = this; //einige Widgets wie Tabcontainer platzieren ihre Events auf window.sidebar!

        // einmal title setzen damit eine eventuell vorhandener productName gesetzt wird
        this.setTitles(null);
    }

    private _checkResponsiveLayout(evt?: Event) {
        // definierte Breiten im CSS auslesen
        let css = window.getComputedStyle(this.domNode);
        let sidebarWidth = css.getPropertyValue("--openSidebarWidth"); //this.verticalContainer.style.getPropertyValue("--openSidebarWidth");
        if (sidebarWidth) this.sidebarWidth = sidebarWidth;
        let collapsedSidebarWidth = css.getPropertyValue("--collapsedItemWidth"); // this.verticalContainer.style.getPropertyValue("--collapsedItemWidth");
        if (collapsedSidebarWidth) {
            this.collapsedWidth = collapsedSidebarWidth;
            this.domNode.style.setProperty("--elementWidth", collapsedSidebarWidth);
        }


        if (window.innerWidth <= this.responsiveThresholdPX) {
            this.collapsedWidth = "0px"; // das computed css liefert anscheinend nicht das, was im media query drinsteht... also wieder händisch nachhelfen.

            if (this._isSidebarPinned) {
                this.pinSidebar(false, false);
            }
        }

        if (!this.isOpened) {
            this.applyPaddingToMainContent(this.collapsedWidth);
        }
    }

    startup(): void {
        super.startup.apply(this, arguments as any);

        this.cornerLinkHome.href = window.appRoot;

        this.init();
    }

    private readInitialMainContentPadding(): void {
        this.applyPaddingToMainContent(null); // die eigene Kalkulation rausnehmen

        let style = window.getComputedStyle(this.mainContentNode);
        // dann auslesen was Sache ist
        
        this._initialMainContentPadding = style.paddingLeft;
        this.mainContentNode.style.setProperty("--initialPadding", this._initialMainContentPadding);
        this.UiModder.domClass.add(this.domNode, "_initialPaddingSet")


        let transitionValue = style.getPropertyValue("--transitionDurationLong");
        let transitionValueSlow = style.getPropertyValue("--transitionDurationShort");

        //console.debug(this.id + ": initial padding of main content is " + this._initialMainContentPadding, style, transitionValue, transitionValueSlow);

        if (transitionValue) {
            try {
                if (transitionValue.substr(-2) == "ms") {
                    let numberValue = parseFloat(transitionValue.substring(0, transitionValue.length - 2));
                    this.animationSpeedMS = numberValue;
                }
                else if (transitionValue.substr(-1) == "s") {
                    let numberValue = parseFloat(transitionValue.substring(0, transitionValue.length - 1));
                    this.animationSpeedMS = numberValue * 1000;
                }

                this.domNode.style.setProperty("--animationSpeed", this.animationSpeedMS + "ms");

                this.domNode.style.setProperty("--animationDelay", this.animationDelayMS + "ms");
                this.domNode.style.setProperty("--animationSpeedShort", this.animationSpeedMS - this.animationDelayMS + "ms");

            } catch (ex) {

            }
        }


        // dann erneut anwenden:
        if (this._currentSession && this._currentSession.isSessionOpen())
            this.applyPaddingToMainContent(this.currentExtraPadding);
    }

    private _isInitialized: boolean = false;
    private init(): void {
        this.mainContentNode = document.getElementById("mainContent");
        if (!this.mainContentNode) {
            alert(this.id + ": no main content node found!");
            return;
        }

        this._isInitialized = true;

        try {
            let cornerLogoElement = document.getElementById("topBar_logoContainer");
            if (cornerLogoElement) {
                let copy = lang.clone(cornerLogoElement);
                domClass.remove(copy, "w3-hide-small");
                //domClass.add(copy, "w3-hide-small");
                domConstruct.place(copy, this.logoContainerSmall);
            }
        } catch (ex) {

        }

        //setTimeout(lang.hitch(this, this.readInitialMainContentPadding), 200);
        // Race Condition... manchmal sind noch nicht alle Styles endgültig berechnet und dann stimmts ausgelesene Padding noch nicht
        //
        //this.readInitialMainContentPadding();

        this.domNode.style.setProperty("--animationSpeed", this.animationSpeedMS + "ms");

        this.domNode.style.setProperty("--animationDelay", this.animationDelayMS + "ms");
        this.domNode.style.setProperty("--animationSpeedShort", this.animationSpeedMS - this.animationDelayMS + "ms");

        let windowHelper: Sidebar.WindowExtended = window as any;

        if (windowHelper.showLanguageSelector === false || windowHelper.showLanguageSelector === true) {
            if (!windowHelper.showLanguageSelector) {
                this._setLangSelectVisibleAttr(false);
            }
        }

        if (windowHelper.showSidebarPin === false || windowHelper.showSidebarPin === true) {
            domClass.toggle(this.sidebarPinButton, "w3-hide", windowHelper.showSidebarPin != true);

        }
        if (windowHelper.pinSidebar === true || windowHelper.pinSidebar === false) {
            this._isSidebarPinned = windowHelper.pinSidebar;
            this.isPinned = this._isSidebarPinned;
        }

        if (typeof (this.pinTarget) == "boolean") {
            this._isSidebarPinned = this.pinTarget;
            this.isPinned = this._isSidebarPinned;
            this.pinTarget = null;
        }


        //// Breite auslesen
        //this.UiModder.domClass.add(this.domNode, "widthTesting");


        //let cssWidth = css.width;


        //let width = this.domNode.getBoundingClientRect().width;
        //if (width < 100) {
        //    this.domNode.style.setProperty("--collapsedSidebarWidth", cssWidth);
        //}

        //this.UiModder.domClass.remove(this.domNode, "widthTesting");

        this._checkResponsiveLayout();

        //window.addEventListener("resize", lang.hitch(this, this._checkResponsiveLayout, 100))
        this.addSubscription("/Global/Resize", lang.hitch(this, this._checkResponsiveLayout)); // Achtung: muss auf layout.cshtml feuern!
        this.addSubscription("/Session/NewSession", lang.hitch(this, this._onSessionChange)); //
        this.addSubscription("/Session/UserrolesUpdated", lang.hitch(this, this._onRolesUpdated)); //
        this.addSubscription("/Session/Loading", lang.hitch(this, this._onSessionLoading)); //
        this.addSubscription("/Session/Open", lang.hitch(this, this._onCheckForExistingSessionResult)); //
        this.addSubscription("/Session/CheckForExistingSession", lang.hitch(this, this._onCheckForExistingSessionResult));
        this.addSubscription("/Session/Close", lang.hitch(this, this._onCheckForExistingSessionResult));
        this.addSubscription("/Session/Closing", lang.hitch(this, this._onClosingSession));
        this.addSubscription("/Session/SubstutitionsAvailable", lang.hitch(this, this._onSubstitutionsAvailable));

        this.addSubscription("Theme/Change", lang.hitch(this, this._onSetTheme));

        this.addSubscription("/Sidebar/Pin", lang.hitch(this, this.tryPinSidebar));
        this.addSubscription("/Sidebar/Toggle", lang.hitch(this, this.toggleOpen));

        this.checkForExistingSession();

    }

    private _onSetTheme(targettheme: string) {

    }
    private _onClick_UserSubstitution() {

        if (!this.hasFeature("system/enableusersubstitution")) return;

        let callback = lang.hitch(this, this._onSubstitutionChange);

        let substForm = new UserSubstitutionForm;

        substForm.setupAsDialog();

    }

    private _onSubstitutionChange() {
        location.reload();
    }

    private _onClick_ThemeToggle() {
        topic.publish("Theme/RequestChange");
    }

    private _onClick_ToggleBaseCSS() {
        let wdw = window as any;
        if (wdw.ToggleCustomStyle) wdw.ToggleCustomStyle();
    }
    private _onClick_ThemeToggleApril1st() {
        this.UiModder.domClass.toggle(document.body, "april1st");
    }

    private _onClick_DEVmenu(evt) {
        let menu = new FloatingMenu();

        //menu.addEntry({
        //    callback: lang.hitch(this, this._onClick_ThemeToggleApril1st),
        //    label: "1. April",
        //    icon: "fas fa-smile-wink",
        //    groupname: "DEV"
        //});


        menu.addEntry({
            callback: lang.hitch(this, this._onClick_ThemeToggle),
            label: "Darkmode",
            icon: "fas fa-moon",
            groupname: "DEV"
        });

        menu.addEntry({
            callback: lang.hitch(this, this._onClick_ToggleBaseCSS),
            label: "baseCSS",
            icon: "fas fa-swatchbook",
            groupname: "DEV"
        });

        menu.addEntry({
            callback: lang.hitch(this, this.releaseSession),
            label: "Sessions freigeben",
            icon: "fas fa-unlink",
            groupname: "DEV",
            heading: "DEV",
            coloration: "mds-text-orange"
        });
        menu.open(evt);
    }

    private _onClick_menu(evt) {

        this._prepareMenuEntries();

        if (this._availableMenuEntries.length == 0) return;

        let menu = new FloatingMenu();

        for (let entry of this._availableMenuEntries) {
            menu.addEntry(entry);
        }

        menu.open(evt);
    }

    private _availableMenuEntries: Array<{ callback: Function, label: string, icon: string, groupname?: string, heading?: string, coloration?: string }> = [];

    destroy() {
        super.destroy.apply(this, arguments as any);
    }
}

export default mdsWidget(DynamicSidebar);
